"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericValidator = void 0;
const lodash_1 = require("lodash");
const util = require("util");
/**
 * A generic validator used to validate simple rules, specified passing a validatorFunction to the constructor.
 */
class GenericValidator {
    /**
     * Constructor
     * @param config the rule configuration
     * @param validatorFunction the validatorFunction to be executed when this rule is checked
     * @param defaultErrorMessage the default error message to return in case of failure if a custom one is not specified.
     */
    constructor(config, validatorFunction, defaultErrorMessage, evaluateEmptyString = false) {
        this.type = () => this.config.type;
        this.config = config;
        this.validatorFunction = validatorFunction;
        this.defaultErrorMessage = defaultErrorMessage;
        this.evaluateEmptyString = evaluateEmptyString;
    }
    evaluate(path, data) {
        const value = lodash_1.get(data, this.config.path || path);
        if ((value || this.evaluateEmptyString) && !this.validatorFunction(value)) {
            return {
                valid: false,
                field: path,
                message: this.config.errorMessage ||
                    util.format(this.defaultErrorMessage, path),
            };
        }
        return { valid: true };
    }
}
exports.GenericValidator = GenericValidator;
//# sourceMappingURL=GenericValidator.js.map